import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import isEqual from "lodash/isEqual";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function checkIfDataHasChanges<T extends Record<string, any>>({ data, originalData }: { data: Partial<T>; originalData: T | undefined }): boolean {
  return Object.entries(data).some(([key, newValue]) => {
    const originalValue = originalData?.[key as keyof T];
    return !isEqual(newValue, originalValue);
  });
}

